// network-status.service.ts
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private status$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private ngZone: NgZone) {
    this.listenToNetworkChanges();
  }

  private listenToNetworkChanges() {
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    )
    .pipe(startWith(navigator.onLine))
    .subscribe(status => {
      this.ngZone.run(() => this.status$.next(status));
    });
  }

  get onlineStatus$() {
    return this.status$.asObservable();
  }
}
